"use strict";

import SimpleBar from "simplebar";
import 'simplebar/dist/simplebar.css';
import ResizeObserver from 'resize-observer-polyfill';
import Tracking from "./tracking";

window.ResizeObserver = ResizeObserver;

const PopinManager = {
    els: [],
    _lastOpen: null,
    _keydownHandler: null,

    init: function () {
        this.els = document.querySelectorAll(".popinVideo--, .popinChercheur--");
        const popin = document.querySelector(".c-popin");

        if (!popin || !this.els.length) return;

        this.els.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                const isVideo = el.classList.contains("popinVideo--");
                this._lastOpen = el;
                this.showPopin(el, popin, isVideo ? "video" : "chercheur");


                // Create a focus guard element
                const focusGuard = document.createElement('button');
                focusGuard.className = 'focus-guard';
                focusGuard.setAttribute('tabindex', '0');
                focusGuard.style.position = 'absolute';
                focusGuard.style.opacity = '0';
                focusGuard.style.pointerEvents = 'none';
                focusGuard.setAttribute('aria-hidden', 'true');

                popin.append(focusGuard);

                // Add event listener to the focus guard
                focusGuard.addEventListener('focus', () => {
                    // When focus guard gets focus, move to first focusable element
                    const firstFocusable = popin.querySelector(
                        'button:not(.hide):not([disabled]), a[href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
                    );
                    if (firstFocusable) {
                        firstFocusable.focus();
                    }
                });
            });
        });

        const closeButton = popin.querySelector(".c-popin__close");
        if (closeButton) {
            closeButton.addEventListener("click", () => this.hidePopin(popin));
        }

        const overlay = popin.querySelector(".c-popin__overlay");
        if (overlay) {
            overlay.addEventListener("click", () => this.hidePopin(popin));
        }
    },
    // destroy: function () {
    //     const popin = document.querySelector(".c-popin");
    //     if (popin) {
    //         popin.querySelectorAll('.focus-guard').forEach(el => el.remove());
    //         const closeButton = popin.querySelector(".c-popin__close");
    //         const overlay = popin.querySelector(".c-popin__overlay");
    //         if (closeButton) closeButton.removeEventListener("click", this.hidePopin);
    //         if (overlay) overlay.removeEventListener("click", this.hidePopin);
    //     }
    //     this.els?.forEach((el) => {
    //         el.replaceWith(el.cloneNode(true));
    //     });
    // },
    showPopin: function (trigger, popin, type) {
        // Reset classes and contents
        popin.classList.remove("video--", "chercheur--");

        // Ajoute la bonne classe selon le type
        popin.classList.add("show--", `${type}--`);
        popin.setAttribute("aria-hidden", "false");
        document.body.classList.add("no-scroll");

        PopinManager.focusFirstElement(popin);

        this._keydownHandler = (e) => {
            PopinManager.trapFocus(popin, e, () => this.hidePopin(popin));
        };
        document.addEventListener("keydown", this._keydownHandler);

        if (type === "video") {
            this.loadVideo(trigger, popin);
        } else {
            this.loadChercheur(trigger, popin);
        }
    },
    hidePopin: function (popin) {
        popin.setAttribute("aria-hidden", "true");
        const isVideo = popin.classList.contains("video--");
        if (isVideo) {
            PopinManager.stopVideo(popin);
        }

        popin.classList.remove("show--", "video--", "chercheur--");
        document.body.classList.remove("no-scroll");

        document.removeEventListener("keydown", this._keydownHandler);
        this._keydownHandler = null;

        popin.querySelector(".c-popin__title").innerHTML = "";
        popin.querySelector(".c-popin__jobPosition").innerHTML = "";
        popin.querySelector(".c-popin__content").innerHTML = "";
        popin.querySelector(".youtube_player").setAttribute('videoid', "");
        popin.querySelector(".c-popin__player button")?.classList.remove("hide");
        popin.querySelector('.c-popin__ctn').classList.remove('isYoutubeShort');
        if (this._lastOpen) {
            this._lastOpen.focus();
            this._lastOpen = null;
        }
    },
    loadVideo: function (el, popin) {
        const id = el.getAttribute("data-id");
        const title = el.getAttribute("data-title");
        const isShortsVideo = el.classList.contains("isYoutubeShort");
        if(isShortsVideo) {
            popin.querySelector('.c-popin__ctn').classList.add('isYoutubeShort');
        }

        popin.querySelector(".c-popin__title").innerHTML = `<h3 class="h3">${title}</h3>`;

       /* if (tarteaucitron && tarteaucitron.state.youtube) {
            const url = `https://www.youtube-nocookie.com/embed/${id}?theme=dark&rel=0&controls=1&showinfo=0&mute=0&autoplay=0&playsinline=1`;
            popin.querySelector(".youtube_player").innerHTML =
                `<iframe frameborder="0" allowfullscreen="1" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" title="${title}" width="100%" height="100%" src="${url}"></iframe>`;
        } else {
            const playerTac = popin.querySelector('.youtube_player');
            if (playerTac) {
                playerTac.setAttribute('videoid', id);
            }
        }*/
        const url = `https://www.youtube-nocookie.com/embed/${id}?theme=dark&rel=0&controls=1&showinfo=0&mute=0&autoplay=0&playsinline=1`;
        popin.querySelector(".youtube_player").innerHTML =
            `<iframe frameborder="0" allowfullscreen="1" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" title="${title}" width="100%" height="100%" src="${url}"></iframe>`;

        Tracking.pushVirtualPageView({
            title: title+' - '+id,
            type: 'video_popin'
        });
    },
    stopVideo: function (popin) {
        const iframe = popin.querySelector("iframe");
        if (iframe) {
            let src = iframe.getAttribute("src");
            src = src
                .replace(/[\?&]autoplay=[0-1]/, "")
                .replace(/[\?&]muted=[0-1]/, "")
                .replace(/[\?&]playsinline=[0-1]/, "")
                .replace(/[&?]$/, "");
            iframe.setAttribute("src", src);
        }
    },
    loadChercheur: function (el, popin) {
        const apiUrl = el.closest('.c-card').getAttribute("data-api");
        if (!apiUrl) {
            console.error("API manquante !");
            return;
        }

        popin.querySelector(".c-popin__player button.tarteaucitronAllow")?.classList.add("hide");

        fetch(apiUrl)
            .then((res) => res.ok ? res.json() : Promise.reject("Erreur API"))
            .then((data) => {
                const contentData = data?.data?.content || {};
                const title = contentData.title ? `<h3 class="h2">${contentData.title}</h3>` : "";
                const job_position = contentData.job_position || "";
                const content = `
                    <div class="c-popin__content-img">${contentData.picture || ""}</div>
                    <div class="c-popin__content-description">
                        ${contentData.text || ""}
                    </div>`;

                popin.querySelector(".c-popin__title").innerHTML = title;
                popin.querySelector(".c-popin__jobPosition").innerHTML = job_position;
                popin.querySelector(".c-popin__content").innerHTML = content;

                const container = popin.querySelector(".c-popin__container");
                if (window.matchMedia("(max-width: 1024px)").matches) {
                    new SimpleBar(container, {autoHide: false, forceVisible: true});
                } else {
                    new SimpleBar(container);
                }

                Tracking.pushVirtualPageView({
                    title: contentData.title,
                    type: 'chercheur_popin'
                });
            })
            .catch((err) => console.error("Erreur API :", err));

    },
    focusFirstElement: function (el, skip = true) {
        const elements = el.querySelectorAll('a, button');
        if (elements) {
            if (skip) {
                if (elements[1]) {
                    elements[1].focus();
                } else {
                    elements[0].focus();
                }
            }
            elements[0].focus();
        }
    },
    trapFocus: function (popin, e, closeFunction) {
        const focusableElements = Array.from(popin.querySelectorAll(
            'button:not(.hide):not([disabled]), a[href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), iframe, .focus-guard'
        )).filter(el => {
            // Additional check for visibility and display
            const style = window.getComputedStyle(el);
            return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
        });

        let isTabPressed = e.key === "Tab" || e.keyCode === 9;
        let isEscPressed = e.key === "Escape" || e.keyCode === 27;

        if (isTabPressed) {
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if (e.shiftKey && document.activeElement === firstElement) {
                e.preventDefault();
                lastElement.focus();
            } else if (!e.shiftKey && document.activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
            }
        }

        if (isEscPressed) {
            if (closeFunction) {
                closeFunction();
            }
        }
    },
};

export default PopinManager;
